import { Subtenant } from '@bioliberty/lifemind';
import { useMemo } from 'react';
import { InternalUtilization } from '../../api/internal';
import { useTenantIds } from '../../hooks/useTenantIds';
import { UtilizationMetric } from '../components/utilizationMetrics';
import { buildUtilizationData } from './utilizationAggregates';

export interface MonthColumn {
  key: string;
  year: number;
  month: number;
  label: string;
}

export interface ClinicRow {
  tenantId: string;
  label: string;
  firstActiveMonth: string | null;
  cells: Map<string, number>;
}

export interface UtilizationData {
  clinics: ClinicRow[];
  months: MonthColumn[];
  totals: Map<string, number>;
}

export function useUtilizationData(
  utilization: InternalUtilization | undefined,
  subtenants: Subtenant[] | undefined,
  metric: UtilizationMetric
): UtilizationData {
  const tenantIds = useTenantIds();

  return useMemo(
    () => buildUtilizationData(utilization, subtenants, tenantIds, metric),
    [utilization, subtenants, tenantIds, metric]
  );
}
